import React, { useState, useEffect, useRef, useCallback } from 'react';
import logo from './logo.svg';
import './App.css';
import { VMDashboardContainer } from './VMDashboard';
import { getUrlParams } from './urlParams';
import { AuthProvider, useAuth } from './voteMachine/vmAuthenticate';
import { getAuth } from 'firebase/auth';


/*
import { app, analytics, auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

const AuthenticatedApp = () => {
  const { user, isLoading, isAuthenticated } = useAuth();
  const userId = user?.userId;
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <VMDashboardContainer  />;
};
*/

function App() {
  //const { isAuthenticated, isLoading } = useAuth();

  //if (isLoading) {
  //  return <div>Loading...</div>;
  //}
  useEffect(() => {

    const auth = getAuth();
    console.log("Auth object on app init:", auth);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <VMDashboardContainer />
      </AuthProvider>
    </div>
  );
}

export default App;
